module.exports = __webpack_public_path__ + "static/mktg-924c1d69fd9c97411a900523b936bb08.png";